import { jsx as _jsx } from "react/jsx-runtime";
import { TextLayer } from "pdfjs-dist";
import { memo, useLayoutEffect, useRef } from "react";
import { PDFPageTextLayerEnd } from "./components/PDFPageTextLayerEnd";
import { useHighlightSearchResults } from "./hooks/useHighlightSearchResults";
export const PDFPageTextLayer = /*#__PURE__*/ memo((param)=>{
    let { pdfPage, pageViewport, pageNumber } = param;
    const containerRef = useRef(null);
    const textLayerRef = useRef();
    const isMounted = useRef(false);
    const { onTextLayerRendered } = useHighlightSearchResults({
        pageNumber,
        containerRef
    });
    const onTextLayerRenderedRef = useRef(onTextLayerRendered);
    onTextLayerRenderedRef.current = onTextLayerRendered;
    useLayoutEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    useLayoutEffect(()=>{
        const renderTextLayer = async ()=>{
            if (!containerRef.current) return;
            if (!!textLayerRef.current) {
                textLayerRef.current.update({
                    viewport: pageViewport,
                    onBefore: ()=>{
                        if (containerRef.current) containerRef.current.hidden = true;
                    }
                });
                containerRef.current.hidden = false;
                return;
            }
            containerRef.current.hidden = true;
            textLayerRef.current = new TextLayer({
                textContentSource: pdfPage.streamTextContent({
                    includeMarkedContent: true,
                    disableNormalization: true
                }),
                container: containerRef.current,
                viewport: pageViewport
            });
            try {
                await textLayerRef.current.render();
                if (!isMounted.current) {
                    return;
                }
                onTextLayerRenderedRef.current(textLayerRef.current.textDivs, textLayerRef.current.textContentItemsStr);
                containerRef.current.hidden = false;
            } catch (error) {
                if (error instanceof Error && error.name === "AbortException") return;
                console.error("Error rendering text layer", error);
            }
        };
        renderTextLayer();
        return ()=>{
            var _textLayerRef_current;
            (_textLayerRef_current = textLayerRef.current) === null || _textLayerRef_current === void 0 ? void 0 : _textLayerRef_current.cancel();
        };
    }, [
        pageViewport,
        pdfPage
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pdfTextLayer",
        ref: containerRef,
        children: /*#__PURE__*/ _jsx(PDFPageTextLayerEnd, {})
    });
});
PDFPageTextLayer.displayName = "PDFPageTextLayer";
